import { TemplateCard } from 'opensolar-common'
import { Box, DialogContent, Typography } from 'opensolar-ui'
import useTranslateWithVariable from 'projectSections/hooks/useTranslateWithVariable'
import { TemplateLibraryCardGrid, TemplateLibraryDialogShell } from 'projectSections/sections/proposal/templateLibrary'
import React from 'react'
import { useTranslate } from 'react-admin'
import { ProposalTemplateTypeEnum } from './types'

export const BESPOKE_REQUEST_URL = 'https://www.opensolar.com/enterprise-services/#expert-h2'

export type ProposalTemplateOption = {
  buttonText?: string
  cardBody: string
  cardImgSrc: string
  cardTag?: string
  cardTitle: string
  cardTitleVars?: Record<string, string>
  id: string
  mode: ProposalTemplateTypeEnum
  testId?: string
  url?: string
}

type ProposalTemplateCreateModalProps = {
  onClose: () => void
  onSelectMode: (mode: ProposalTemplateTypeEnum) => void
  onTransitionExited?: () => void
  open: boolean
  options: ProposalTemplateOption[]
}

const ProposalTemplateCreateModal: React.FC<ProposalTemplateCreateModalProps> = ({
  onClose,
  onSelectMode,
  onTransitionExited,
  open,
  options,
}) => {
  const translate = useTranslate()
  const translateWithVariable = useTranslateWithVariable()

  return (
    <TemplateLibraryDialogShell
      id="proposal-template-create-modal"
      onClose={onClose}
      open={open}
      title={translate('Sales Machine Proposal Templates')}
      transitionProps={onTransitionExited ? { onExited: onTransitionExited } : undefined}
    >
      <DialogContent style={{ padding: 0 }}>
        <Box padding="0 20px">
          <Typography textVariant="body1">
            {translate('Choose a template to create a proposal for your customer')}
          </Typography>
        </Box>
        <TemplateLibraryCardGrid>
          {options.map((option) => {
            const header = option.cardTitleVars
              ? translateWithVariable(option.cardTitle, option.cardTitleVars)
              : translate(option.cardTitle)

            return (
              <TemplateCard
                body={translate(option.cardBody)}
                disabled={false}
                header={header}
                height="auto"
                id={`proposal-template-card-${option.id}`}
                imgSrc={option.cardImgSrc}
                key={option.id}
                selected={false}
                tag={option.cardTag ? translate(option.cardTag) : undefined}
                testId={option.testId}
                {...(option.buttonText && option.url
                  ? {
                      buttonText: translate(option.buttonText),
                      onButtonClick: () => window.open(option.url, '_blank', 'noopener,noreferrer'),
                      ...(option.id === 'proposalV2' && { onSelect: async () => onSelectMode(option.mode) }),
                    }
                  : { onSelect: async () => onSelectMode(option.mode) })}
              />
            )
          })}
        </TemplateLibraryCardGrid>
      </DialogContent>
    </TemplateLibraryDialogShell>
  )
}

export default ProposalTemplateCreateModal
